
export class DocumentInput {

    url: string;
    name: string;
    status: boolean;
    companyGroupId: string;
}
